import useTranslation from 'next-translate/useTranslation';

import styles from './feature-intrapreneur-challenge.module.less';

/* eslint-disable-next-line */
export interface FeatureIntrapreneurChallengeProps {}

export function FeatureIntrapreneurChallenge(
  props: FeatureIntrapreneurChallengeProps
) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_to_feature_intrapreneur_challenge')}</h1>
    </div>
  );
}

export default FeatureIntrapreneurChallenge;
